import { apiGetAccount } from '../../common/api/profile'
import { apiApproveComment } from '../../common/api/comments'

const fetchComments = (pupilId, params = {}) => ({
  requestPrefix: 'COMMENTS_STORE:FETCH',
  params: { pupilId, ...params },
  request: () =>
    apiGetAccount(pupilId, {
      include: `account.comments,account.comment.timestamps,account.comment.details,account.comment.work,account.comments.limit.10,account.comments.page.${params.page ||
        1}`
    })
})

const approveComment = commentId => ({
  requestPrefix: 'COMMENTS_STORE:APPROVE',
  params: { commentId },
  request: () => apiApproveComment(commentId)
})

export { fetchComments, approveComment }
